var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"all_wrap",attrs:{"id":"app"}},[_c('custom-header',{attrs:{"title":"학습현황"}}),_c('div',{staticClass:"all_layout"},[_c('custom-tab',{attrs:{"active":0}}),_c('keep-alive',[_c('router-view')],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }